import { SHStack } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";

export const OverviewTabSkeleton = () => {
  return (
    <SHStack sx={{ paddingY: 3 }} spacing={3}>
      <SHStack spacing={1}>
        <SHSkeleton height={24} width="18%" delay={false} />
        <SHSkeleton height={20} width="100%" delay={false} />
      </SHStack>
      <SHSkeleton height={2} width="100%" delay={false} />
      <SHStack direction={"row"} justifyContent={"space-between"}>
        <SHStack width="30%" spacing={1}>
          <SHSkeleton height={24} width="60%" delay={false} />
          <SHSkeleton height={20} width="80%" delay={false} />
          <SHSkeleton height={20} width="80%" delay={false} />
        </SHStack>
        <SHStack width="55%" spacing={4}>
          <SHStack direction={"row"} spacing={4} alignItems="center">
            <SHSkeleton height={90} width={90} variant="circular" delay={false} />
            <SHStack spacing={1} flexGrow={1}>
              <SHSkeleton height={24} width="30%" delay={false} />
              <SHSkeleton height={118} width="100%" delay={false} />
            </SHStack>
          </SHStack>
          <SHStack direction={"row"} spacing={4} alignItems="center">
            <SHSkeleton height={90} width={90} variant="circular" delay={false} />
            <SHStack spacing={1} flexGrow={1}>
              <SHSkeleton height={24} width="30%" delay={false} />
              <SHSkeleton height={118} width="100%" delay={false} />
            </SHStack>
          </SHStack>
        </SHStack>
      </SHStack>
      <SHSkeleton height={2} width="100%" delay={false} />
      {/* Banner Group */}
      <SHStack direction={"row"} justifyContent={"space-between"}>
        <SHStack width="30%" spacing={1}>
          <SHSkeleton height={24} width="60%" delay={false} />
          <SHSkeleton height={20} width="80%" delay={false} />
          <SHSkeleton height={20} width="80%" delay={false} />
        </SHStack>
        <SHStack width="45%" spacing={1}>
          <SHStack spacing={1}>
            <SHSkeleton height={24} width="30%" delay={false} />
            <SHSkeleton height={50} width="100%" delay={false} />
          </SHStack>
        </SHStack>
      </SHStack>
    </SHStack>
  );
};
